export default "__VITE_ASSET__fa206deb__"